import React from 'react';
import { Bell } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';
import { NotificationPanel } from './NotificationPanel';
import { useNotificationsContext } from '../../context/NotificationsContext';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

export function NotificationIcon() {
  // Only need badge data, not full list
  const { hasUnread } = useNotificationsContext();

  return (
    <Tooltip>
      <NotificationPanel>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className={cn('relative rounded-full text-muted-foreground hover:text-foreground')}
            aria-label="Open notifications"
          >
            <Bell className="h-5 w-5" />
            {hasUnread && (
              <span
                className="absolute right-1 top-1 inline-flex h-2 w-2 rounded-full bg-destructive shadow-[0_0_0_2px_var(--background)]"
                aria-hidden
              />
            )}
          </Button>
        </TooltipTrigger>
      </NotificationPanel>
      <TooltipContent side="bottom" align="center">
        Notifications
      </TooltipContent>
    </Tooltip>
  );
}

